import type { Dictionnaire } from '../type';

export const profil: Dictionnaire['profil'] = {
  erreurs: {
    compteIntrouvable: 'Account not found',
    membreIntrouvable: 'Member not found',
    pseudoPris: 'This username is already taken',
    spotIntrouvable: 'Spot not found',
    bientot: (spot: string) => `${spot} is opening soon, stay tuned!`,
    prive: (spot: string) => `${spot} is for its members only.`,
  },
  aideErreurs: {
    vide: "Tell us what's going on",
  },
  commun: {
    changerPhoto: 'Change my profile photo',
    mesDestinations: 'My destinations',
    mesPosts: 'My posts',
    mesEvenements: 'My events',
    mesAmis: 'My friends',
    mesSignets: 'My bookmarks',
    voirTout: 'See all',
    notePar: (note: string, n: number) => `Rated ${note} out of 5 by ${n} participant${n === 1 ? '' : 's'}`,
    personnaliser: 'Personalize my profile',
    bio: 'Bio',
    debloquer: 'Unblock',
    membresBloques: 'Blocked members',
    visibilite: 'Profile visibility',
    parametres: 'Settings',
    aide: 'Help and reports',
    ajouterAmis: 'Add friends',
    ecrireA: (nom: string) => `Write to ${nom}`,
  },
  compte: {
    photoMiseAJour: 'Photo updated.',
    photoRetiree: 'Photo removed.',
    photoImpossible: "Couldn't save the photo",
    enregistre: 'Profile saved.',
    impossible: "Couldn't save",
    enregistrer: 'Save',
    retirerPhoto: 'Remove my photo',
    pseudo: 'Username',
    bioExemple: "A couple of lines about you, what you're looking for here...",
    langues: 'Languages you speak',
    languesAide: 'Outings in your languages come first in the list.',
  },
  masques: {
    titre: 'Hidden and blocked',
    comptesMasques: 'Hidden accounts',
    comptesBloques: 'Blocked accounts',
    postsMasques: 'Hidden posts',
    afficher: 'Unhide',
    impossible: 'Not possible right now.',
    comptes: {
      personne: 'No hidden accounts',
      personneAide: 'You can hide an account from its profile, with the three dots at the top right.',
      explication: 'You no longer see their posts or their outings. They don’t know, and nothing else changes between you.',
      masque: 'Hidden',
    },
    posts: {
      aucun: 'No hidden posts',
      aucunAide: 'Posts you hide from the feed end up here.',
    },
  },
  bloques: {
    impossible: "Couldn't unblock right now.",
    personne: 'No one is blocked',
    personneAide: 'You can block a member from their profile, with the three dots at the top right.',
    explication: 'Their posts and events no longer show up for you, and your conversations are hidden.',
    bloque: 'Blocked',
  },
  destinations: {
    villes: 'Cities',
    actuel: 'Current server',
    changer: 'Change server',
  },
  amis: {
    aucun: "You don't have any friends yet",
    aucunAide: 'Server suggestions and received requests are waiting for you.',
    trouver: 'Find members',
  },
  aide: {
    impossible: "Couldn't send right now.",
    envoyer: 'Send',
    intro: "Tell us what's going on. Our team reads everything and replies by email.",
    sujet: 'What is it about?',
    raconte: 'Tell us',
    raconteExemple: 'What happened, where, and with whom if relevant.',
    sujets: {
    member: 'A member',
    event: 'An event',
    content: 'A post or a message',
    bug: 'A technical problem',
    other: 'Something else',
  },
  },
  membre: {
    ami: {
      none: 'Add friend',
      requested: 'Request sent',
      incoming: 'Accept request',
      friends: 'Remove friend',
    },
    ceMembre: 'this member',
    profil: 'Profile',
    refuserQ: 'Decline their friend request?',
    refuser: 'Decline friend request',
    debloquerMembre: 'Unblock this member',
    bloquerMembre: 'Block this member',
    masquerCompte: 'Hide this account',
    nePlusMasquer: 'Unhide this account',
    estMasque: (nom: string) => `${nom} is hidden. You won’t see their posts or events anymore.`,
    plusMasque: (nom: string) => `${nom} is no longer hidden.`,
    ecrire: 'Message',
    tuAsBloque: 'You blocked this member',
    tuAsBloqueAide: "Their posts no longer show up in your feed and they're no longer suggested to you.",
    officiel: "This is the Sirocco team's account. Write to it with any question.",
    reserve: 'Profile visible to friends only',
    reserveAide: 'Send a friend request to see their posts.',
    sesDestinations: 'Their destinations',
    sesEvenementsMasques: 'Their events are hidden by their settings.',
    demandeRefusee: (nom: string) => `${nom}'s request declined.`,
    debloque: (nom: string) => `${nom} is unblocked.`,
    bloquerQ: (nom: string) => `Block ${nom}?`,
    bloque: (nom: string) => `You blocked ${nom}. They can no longer send you messages or friend requests.`,
    retirerAmiQ: (nom: string) => `Remove ${nom} from your friends?`,
    plusAmi: (nom: string) => `${nom} is no longer your friend.`,
    appeler: (nom: string) => `Call ${nom}`,
    avis: (n: string) => `· ${n} review${n === '1' ? '' : 's'}`,
  },
  notifications: {
    choix: {
      messages: 'Messages',
      appels: 'Calls',
      amis: 'Friend requests',
      postsAmis: "My friends' posts",
      evenements: 'Events',
      acceptee: 'Participation accepted',
      inscriptions: 'Sign-ups to my events',
      desinscriptions: 'Cancellations for my events',
      reactions: 'Reactions to my posts',
      mentions: 'Mentions',
    },
    titre: 'Notifications',
  },
  motDePasse: {
    troisConditions: "This password doesn't meet the three requirements",
    pasIdentiques: "The two passwords don't match",
    impossible: "Couldn't change it",
    titre: 'Email and password',
    changer: 'Change my password',
    actuel: 'Current password',
    nouveau: 'New password',
    confirmer: 'Confirm the new password',
    envoye: 'Email sent',
    lienRecu: (email: string) => `Open the link sent to ${email} to choose a new password.`,
  },
  ecran: {
    modifier: 'Edit my profile',
    mesEvenementsSorties: 'My events and outings',
  },
  visibilite: {
    intro: 'Choose what other members of the server see when they open your profile.',
    quiPeutVoir: 'Who can see my profile',
    toutLeServeur: 'The whole server',
    amisSeulement: 'My friends only',
    ceQuiApparait: 'What appears on my profile',
    evenementsAide: 'Others can see what I take part in',
    mesDestinationsAide: 'The cities I’ve been to',
    postsAide: 'Visible from my profile',
    enLigne: 'Online status',
    enLigneAide: 'Green dot on my avatar',
    destinationsAmis: 'My destinations to friends only',
    destinationsAide: "The cities I've been through, for my friends only",
    messages: 'Messages',
  },
  tableau: {
    mois: 'Last 30 days',
    posts: 'posts',
    tenues: 'events held',
    presences: 'check-ins',
    inscriptions: 'Sign-ups per week',
    cetteSemaine: 'this week',
    ilYaSemaines: (n: number) => `${n} wk ago`,
    nInscriptions: (n: number) => (n === 1 ? '1 sign-up' : `${n} sign-ups`),
    fidelite: 'Retention',
    revenus: 'come back after their first week',
    encoreActifs: 'still active after a month',
    surN: (n: number, sur: number) => `${n} of ${sur}`,
    pasAssez: 'not enough history yet',
    parServeur: 'By server',
    serveurLigne: (membres: number, actifs: number) =>
      `${membres} member${membres === 1 ? '' : 's'} · ${actifs} active this week`,
    serveurDetail: (posts: number, tenues: number, presences: number, aVenir: number) =>
      `${posts} post${posts === 1 ? '' : 's'} (7 d) · ${tenues} event${tenues === 1 ? '' : 's'} and ${presences} check-in${presences === 1 ? '' : 's'} (30 d) · ${aVenir} upcoming`,
    sansServeur: 'no server',
    titre: 'Dashboard',
    actifsAujourdhui: 'active today',
    semaine: 'this week',
    comptes: 'accounts',
    nouveaux: 'new (7 d)',
    unSignalement: '1 report awaiting a decision',
    connexions: 'Latest sign-ins',
    versions: 'Installed versions',
    unCompte: '1 account',
    sorties: 'Upcoming outings',
    rien: 'Nothing planned yet.',
    spontanee: 'spontaneous',
    jamais: 'never',
    depuis: {
    minutes: (n: number) => `${n} min ago`,
    heures: (n: number) => `${n} h ago`,
    jours: (n: number) => `${n} d ago`,
  },
    build: (n: string) => ` · build ${n}`,
    signalements: (n: number) => `${n} reports awaiting a decision`,
    nComptes: (n: number) => `${n} accounts`,
  },
  reglages: {
    apparences: {
      system: 'Automatic',
      day: 'Light',
      night: 'Dark',
    },
    apparenceAide: {
      system: "Follows your phone's setting.",
      day: 'Always light, whatever the phone.',
      night: 'Always dark, whatever the time.',
    },
    deconnexionImpossible: "Couldn't sign out. Try again.",
    suppressionImpossible: "Couldn't delete",
    compte: 'Account',
    emailEtMotDePasse: 'Email address and password',
    serveur: 'Server / destination',
    confidentialite: 'Privacy',
    coupees: "Turned off in your phone's settings",
    moderation: 'Moderation',
    tableau: 'Dashboard',
    administration: 'Administration',
    application: 'App',
    apparence: 'Appearance',
    langue: 'Language',
    deconnecterQ: 'Sign out?',
    deconnecter: 'Sign out',
    supprimerQ: 'Permanently delete your account? Your posts and messages will be erased.',
    supprimer: 'Delete my account',
  },
};
